import { List } from '@material-ui/core'

import { useProject } from '@/pages/projects-form/contexts/project-context'

import { RegionItem } from './region-item'
import { useStyles } from './styles'

export function Regions() {
  const classes = useStyles()

  const {
    form: { watch },
    context: { activeStep, activeRegionName, setActiveRegionName },
  } = useProject()

  const regions = watch('regions').filter((region) => !region.removed)

  const shouldToShowRegions = activeStep === 2 && Boolean(regions.length)

  return (
    <>
      {shouldToShowRegions && (
        <List className={classes.container}>
          {regions.map((region) => (
            <RegionItem
              key={region.name}
              label={region.name}
              ready={Boolean(region.geojson)}
              selected={activeRegionName === region.name}
              onClick={() => setActiveRegionName(region.name)}
            />
          ))}
        </List>
      )}
    </>
  )
}
